import React, {memo, useCallback} from 'react';
import PropTypes from 'prop-types';
// import SelectElementCmp from '@/utils/SelectElementCmp';
import ClientsApiService from '@/modules/clients/services/ClientsApiService';
import {useGetOneClients} from '@/modules/clients/hooks/useClients';
import SelectElementCmpOld from '@/utils/SelectElementCmpOld';

const SelectClient = ({ value, onChange, setClient, form, ...props }) => {

  const handleOnChange = useCallback((val) => {
    setClient(val);
    onChange(val);
    form.setFieldsValue({establishments: [], areas: []});
  }, [form, onChange, setClient]);

  return (
    <SelectElementCmpOld
      queryKey={'register-client-select'}
      key={'register-client-select'}
      service={ClientsApiService}
      customMethod="/ms-core/api/structures/search"
      // includeValue={''}
      value={typeof value === 'object' ? value?._id : value}
      onChange={handleOnChange}
      sort={{ code: 1 }}
      queryConfig={{ refetchOnWindowFocus: false }}
      className="custom-select"
      {...props}
      filters={null}
    />
  );
};

SelectClient.propTypes = {
  value: PropTypes.string || PropTypes.object,
  onChange: PropTypes.func,
  filters: PropTypes.object,
  setClient: PropTypes.func,
  form: PropTypes.object,
};
SelectClient.defaultProps = {
  entity: {},
};

export default memo(SelectClient);

const ClientView = ({value}) => {

  const {data} = useGetOneClients({id: value?._id || value});

  return (
    <div>
      {value?.name ? value?.name : data?.data?.name || 'N/A'}
    </div>
  );
};

ClientView.propTypes = {
  value: PropTypes.string
};

/**
 * cellRender
 * */
/**
 * This is not a component,
 * it is a function to render the Code component in a table cell
 * @param {String} text this is the value of the dataIndex of the table
 * */
export const renderClient = (text) => {
  return (
    <ClientView value={text}/>
  );
};
